export default "__VITE_ASSET__b77adaff__$_?component__"